<template>
  <div v-if="awards.length" class="page">
    <div class="wrapper">
      <div class="top">
        <div class="left">
          <img :src="avatar" class="avatar" />
          <div class="name">{{ alias }}</div>
        </div>
        <div class="record-enter" @click="toRecord">
          <div class="record-enter-item">我的中奖记录</div>
          <!-- <div class="record-enter-item cover"></div> -->
        </div>
      </div>
      <div class="slogan">有奖答题</div>
      <div class="content">
        <div
          class="content-box"
          v-for="(item, index) in awards"
          :key="index"
          :style="animateIndex == index ? 'opacity:0.3' : ''"
        >
          <div class="switch" v-if="index === 4" @click="startOne"></div>
          <div v-else class="awards-item">
            <img
              :src="item.cover[0]"
              mode="aspectFill"
              @click="showPic(item.cover[0])"
              :class="!item.noImg ? 'uImg awards-imgs' : 'awards-imgs'"
            />
            <div class="awards-name">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="overage-count">
        <div class="overage-count-text">剩余抽奖次数 {{ draws_count }}</div>
      </div>
      <div class="awards-rules">
        <div class="awards-rules-title">抽奖规则说明：</div>
        <div class="awards-rules-item">
          答题次数：{{ max_join_count ? max_join_count + "次" : "无限制" }}
        </div>
        <div class="awards-rules-item">中奖次数：{{ award_reoccur }}次</div>
        <div class="awards-rules-item">
          答题后满足获奖要求得分，即可获得一次抽奖机会
        </div>
      </div>
    </div>
    <van-popup
      v-model="showModal"
      :style="{ borderRadius: '8px' }"
      closeable
      close-icon="close"
      @closed="closedSetting"
    >
      <div class="mask-content mh">
        <div class="container">
          <div class="award-box">
            <div class="congrats-text">
              {{ win_status ? "· 恭喜中奖 · " : "· 未中奖 · " }}
            </div>
            <img
              :class="['phone-image', { cover: win_status }]"
              mode="aspectFill"
              :src="win_status ? target.imgs[0] || prize_default_img : fail_img"
            />
            <div v-if="win_status">
              <div class="medal">
                <label class="award-level">{{
                  awardsLength > 1 ? prize_order[target.index] + "等奖" : "奖品"
                }}</label>
              </div>
              <div class="prize-info">{{ target.title }}</div>
            </div>
            <div v-else>
              <div class="tsx">谢谢参与</div>
              <div class="fail-tip">好运总是眷顾努力坚持的人</div>
            </div>
            <button class="claim-btn" @click="handleClaim">
              {{
                win_status ? "前往领奖" : draws_count ? "再抽一次" : "再次答题"
              }}
            </button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import { Toast, ImagePreview } from "vant";
import { getToken, reLogin, setShareInfo } from "@/utils/common";
let go = null;
export default {
  data() {
    return {
      awardsLength: 1,
      showModal: false,
      animateIndex: -2,
      animate: false,
      qid: "",
      awards: [],
      draws_count: 0,
      initCover:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220114/802bb5a58baca4bf679d57bb21ceca93.png",
      lossCover:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220114/d5a99c647ba1e818c9cb8bc290d0820e.png",
      win_status: 1,
      prize_order: "一二三四五六七八九十",
      target: {
        index: 0,
        title: "1121212",
        imgs: []
      },
      prize_default_img:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-22/2dcd64e204f1a0e55712daa41ea76dd9.png",
      fail_img:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-02-08/c5bd70e41e7903af4f12ee08f2867f1d.png"
    };
  },
  mounted() {
    this.qid = this.$route.query.qid;
    this.getDetail(this);
    setShareInfo(false);
  },
  methods: {
    showPic(url) {
      let { prize_default_img, initCover, lossCover } = this;
      if (url != prize_default_img && url != initCover && url != lossCover) {
        ImagePreview({
          images: [url],
          closeable: true,
          startPosition: 0
        });
      }
    },
    handleClaim() {
      let { win_status, target, draws_count, awardsLength } = this;
      if (win_status) {
        // 抽中了
        if (target.deliver_way == 0) {
          // 联系微信
          this.$router.push({ name: "awardsCash", query: { rid: target.rid } });
          this.showModal = false;
        } else {
          // 邮寄
          let { index, title } = target;
          let fillName = `${
            awardsLength > 1 ? this.prize_order[index] + "等奖" : "奖品"
          }：${title}`;
          localStorage.setItem(
            "logistics",
            JSON.stringify({
              title: fillName
            })
          );
          this.$router.push({ name: "awardsAddress" });
          this.showModal = false;
        }
      } else {
        if (draws_count) {
          // 还有机会
          this.showModal = false;
          this.startOne();
        } else {
          // 没机会了重新答题
          this.$router.replace({
            name: "normalDetail",
            query: { qid: this.qid }
          });
        }
      }
    },
    closedSetting() {},
    toRecord() {
      this.$router.push({
        name: "awardsList",
        query: { qid: this.qid, tab: 1 }
      });
    },
    startOne() {
      if (this.draws_count < 1) {
        Toast("抽奖次数已用完", { title: "温馨提示" });
        return;
      }
      this.startAnimation();
      setTimeout(() => {
        this.lotto(this);
      }, 1800);
    },
    startAnimation() {
      let indexArrray = [0, 1, 2, 5, 8, 7, 6, 3];
      var index = -1,
        index2 = -1;
      go = setInterval(() => {
        if (index > 6) {
          index = -1;
        }
        if (index2 > 400) {
          clearInterval(go);
          go = null;
        }
        index++;
        index2++;
        this.animateIndex = indexArrray[index];
      }, 80);
    },
    handleLotteryModal() {
      this.win_status = 0;
      this.showModal = true;
    },
    lotto(self) {
      let data = {
        access_token: getToken(),
        qid: self.qid
      };
      questionOnly
        .post("/xcx/ques/v1/award/draws", data)
        .then(res => {
          if (res.sta === 0) {
            if (res.data) {
              let { award_key, win, rid } = res.data;
              let { awards } = self;
              if (win == 1) {
                clearInterval(go);
                go = null;
                for (let i = 0; i < awards.length; i++) {
                  if (awards[i].key === award_key) {
                    let content =
                      "恭喜你抽中奖品：" +
                      awards[i].title +
                      "\n" +
                      ",根据活动说明，联系活动方兑奖哦！";
                    self.animateIndex = i;
                    self.target = { ...awards[i], rid };
                    self.win_status = 1;
                    self.showModal = true;
                    this.getDetail(self, "refresh");
                    return false;
                  }
                }
              } else {
                clearInterval(go);
                go = null;
                self.handleLotteryModal();
                this.getDetail(self, "refresh");
                let emptyArr = awards.filter(item => item.title == "谢谢参与");
                if (emptyArr.length) {
                  for (let i = 0; i < awards.length; i++) {
                    if (awards[i].title === "谢谢参与") {
                      self.animateIndex = i;
                      return false;
                    }
                  }
                } else {
                  self.animateIndex = -2;
                }
              }
            }
          } else {
            self.animateIndex = -2;
            clearInterval(go);
            go = null;
            if (res.sta === -500) {
              reLogin();
            } else {
              Toast(res.msg);
            }
          }
        })
        .catch(res => {
          self.animateIndex = -2;
          clearInterval(go);
          go = null;
        });
    },
    getDetail(self, refresh) {
      var data = {
        qid: self.qid,
        access_token: getToken()
      };
      questionOnly.get("/xcx/ques/v1/award/draws", data).then(res => {
        if (res.sta === 0) {
          let d = res.data;
          let awards = d.awards || [
            {
              min_score: "",
              title: "",
              imgs: [],
              count: ""
            }
          ];
          awards.map((item, index) => {
            item.index = index;
          });
          if (!refresh) {
            let len = 8 - awards.length;
            if (len) {
              for (let i = 0; i < len; i++) {
                awards.push({
                  min_score: "",
                  title: "",
                  imgs: [],
                  count: ""
                });
              }
            }
            awards = awards.sort(function() {
              return 0.5 - Math.random();
            });
            for (const i in awards) {
              awards[i].imgs = awards[i].imgs || [];
              awards[i].cover = awards[i].imgs || [];
              if (!awards[i].imgs.length) {
                awards[i].noImg = 1;
                awards[i].cover = awards[i].title
                  ? [self.initCover]
                  : [self.lossCover];
                awards[i].imgs = awards[i].imgs || [];
              }
              if (!awards[i].title) {
                awards[i].title = "谢谢参与";
              }
            }
            awards.splice(4, 0, {});
            this.awards = awards;
          }
          self.alias = d.alias;
          self.avatar = d.avatar;
          self.award_reoccur = d.award_reoccur;
          self.max_join_count = d.max_join_count;
          self.draws_count = d.draws_count;
          self.awardsLength = d.awards.length;
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  min-height: 100%;
  width: 100%;
}
.wrapper {
  background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/20220114/0a50430125c40924d39d55045e938a74.png");
  background-size: cover;
  min-width: 320px;
  max-width: 500px;
  margin: 0 auto;
  min-height: 100vh;
  padding-bottom: 20px;
}

.top,
.left,
.right {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.top {
  justify-content: space-between;
  padding: rem(30) 0 rem(28) rem(30);
}

.left .avatar {
  width: rem(80);
  height: rem(80);
  min-width: rem(80);
  border-radius: 50%;
  border: rem(4) solid #fff;
  margin-right: rem(10);
}

.left .name {
  font-size: rem(26);
  line-height: rem(39);
  color: #fff;
}

.right {
  justify-content: space-between;
  width: rem(200);
  height: rem(60);
  background-color: #fff;
  color: #fe523c;
  font-size: rem(28);
  border-radius: rem(30);
  padding: 0 rem(10);
}

.right img {
  width: rem(40);
  height: rem(40);
}

.title {
  width: rem(480);
  height: rem(110);
  display: block;
  margin: 0 auto;
}

.contact-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: rem(26);
  color: #fff;
  margin-bottom: rem(10);
}

.contact {
  color: #fff;
  font-size: rem(26);
  padding: rem(20);
}

.content {
  margin: 0 auto;
  width: rem(700);
  height: rem(700);
  padding: rem(60) rem(60) rem(40);
  box-sizing: border-box;
  background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/20220114/0e804a480a2bd6e59aef4f446930535f.png");
  background-size: cover;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.content-box {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  height: rem(180);
  width: rem(180);
  background-color: #fff;
  border-radius: rem(10);
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
  box-shadow: 0px 3px 2px #ffc668;
  box-sizing: border-box;
}
.content-box:nth-child(5) {
  background-color: none;
}

.center-img {
  height: rem(180);
  width: rem(180);
}

.coin-num {
  font-size: rem(28);
  color: #ffcc00;
  position: absolute;
  bottom: rem(30);
  left: 0;
  width: rem(200);
  text-align: center;
}

.tag {
  width: rem(60);
  height: rem(60);
  position: absolute;
  top: 0;
  left: 0;
}

.bottom,
.lotto-btn {
  display: flex;
  display: -webkit-flex;
}

.bottom {
  margin-top: rem(40);
  padding: 0 rem(60);
  justify-content: space-between;
  border: none;
}

.bottom .lotto-btn {
  height: rem(100);
  width: rem(630);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  font-size: rem(36);
  font-weight: bold;
  color: #fe523c;
  border-radius: rem(50);
  box-shadow: 0 6px rgba(255, 255, 255, 0.4);
  position: relative;
  overflow: visible;
}

.lotto-btn label {
  font-size: rem(20);
  font-weight: normal;
  margin-top: rem(12);
}

.discount-img {
  position: absolute;
  width: rem(100);
  height: rem(70);
  right: -rem(40);
  top: -rem(30);
}

.dialog-body {
  overflow: hidden;
  padding-bottom: rem(40);
}

.dialog-body view {
  text-align: center;
  line-height: 1;
}

.award-img {
  width: rem(640);
  height: rem(300);
}

.award-btn {
  height: rem(80);
  width: rem(600);
  margin-left: rem(20);
  background: linear-gradient(to right, #f1daa8, #b18854);
  color: #fff;
  font-size: rem(30);
  margin-top: rem(28);
  text-align: center;
  line-height: rem(80);
  border-radius: rem(10);
}

.lotto-tip {
  font-size: rem(24);
  color: #fff;
  text-align: center;
  margin-top: rem(30);
}

.name-box {
  height: rem(100);
  overflow: hidden;
  border: rem(2) solid #fff;
  width: rem(670);
  margin: 0 auto;
  position: relative;
  border-radius: rem(20);
}

.marquee_top {
  transition: all 1.2s;
  margin-top: -rem(100);
}

.marquee_top1 {
  height: rem(100);
  line-height: rem(100);
  font-size: rem(26);
  color: #fff;
}

.name-box img {
  width: rem(36);
  height: rem(36);
  position: absolute;
  left: rem(38);
  top: rem(32);
  z-index: 100;
}

.swiper_item {
  padding-left: rem(100);
}

.small-tip {
  text-align: center;
  font-size: rem(26);
  color: #fff;
  height: rem(100);
  line-height: rem(100);
}

ad {
  width: rem(480) important;
}

.dialog-close {
  position: absolute;
  bottom: rem(200);
  left: rem(340);
  width: rem(60);
  height: rem(60);
}

.overage-count {
  margin: rem(20) auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overage-count-text {
  display: inline-block;
  padding: rem(4) rem(20);
  background: #ffac41;
  border: rem(2) solid #ffd279;
  border-radius: rem(30);
  color: #ffffff;
  font-size: rem(26);
}

.awards-rules {
  background: rgba(255, 147, 61, 0.4);
  border: rem(2) solid #ffd279;
  border-radius: rem(8);
  margin: 0 rem(30);
  font-size: rem(26);
  line-height: rem(39);
  padding: rem(20) rem(30);
  color: #ffffff;
}

.awards-rules-title {
  font-weight: 900;
}

.slogan {
  text-align: center;
  font-weight: 900;
  font-size: rem(80);
  line-height: rem(120);
  color: #ffffff;
  margin-bottom: rem(40);
}
.record-enter {
  font-size: rem(26);
  line-height: rem(39);
  text-align: center;

  color: #ffffff;
  margin-top: rem(12);
}
.record-enter-item {
  background: #ff9012;
  box-shadow: 0px 4px 0px #ffd99f;
  border-radius: 100px 0px 0px 100px;
  padding: rem(10) rem(30);
  min-width: rem(216);
  box-sizing: border-box;
}
.switch {
  background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/20220114/dbf40f7c4cd025a95264f0eaf3491b3f.png");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.awards-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: rem(22);
  line-height: rem(30);
  text-align: center;
  color: #d18c00;
}
.awards-imgs {
  width: rem(80);
  height: rem(80);
  margin-bottom: rem(10);
}
.awards-imgs.uImg {
  width: rem(90);
  height: rem(90);
  border-radius: rem(8);
  object-fit: cover;
}
.awards-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mask-content {
  position: relative;
  box-sizing: border-box;
  width: 327px;
  background: #fff;
  border-radius: 8px;
  z-index: 1001;
  /* margin-top: -60px; */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #262626;
}

.mask-content.mh {
  min-height: 387px;
}

.mask-image {
  width: 327px;
  height: 387px;
}

.close-btn {
  width: 35px;
  height: 35px;
  min-width: 35px;
  position: absolute;
  bottom: -42px;
}

.replace-icon {
  width: 288.5px;
  height: 342px;
  position: absolute;
  left: 50%;
  top: 0px;
  transform: translate(-50%, 0);
}

.award-box {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-sizing: border-box;
}

.congrats-text {
  display: block;
  font-size: 26px;
  color: #a8071a;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}

.medal {
  text-align: center;
  margin-bottom: 20px;
}
.award-level {
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 4px;
  background: rgba(168, 7, 26, 0.1);
  line-height: 20px;
  color: #a8071a;
  margin: 0 auto;
}

.prize-info {
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: bold;
}
.prize-detail {
  display: block;
  font-size: 14px;
  color: #666;
}

.phone-image {
  width: 100px;
  height: 100px;
  margin: 0 auto 15px;
  border-radius: 4px;
}
.phone-image.cover {
  background: #fafafa;
  width: 110px;
  height: 110px;
  object-fit: cover;
}

.claim-btn {
  background: #a8071a;
  color: white;
  width: 124px;
  height: 45px;
  border-radius: 42px;
  font-size: 16px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tsx {
  font-size: 24x;
  color: #1a1a1a;
  margin-bottom: 8px;
}
.fail-tip {
  font-size: 14x;
  color: #999999;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/lottery/lottery.vue